// State
import { ListingSearchProvider } from 'src/context/listingSearch'

// Components
import Input from './Input'
import Results from './Results'

// Styles
import styles from './SearchModal.module.scss'

const SearchModal = () => (
  <ListingSearchProvider>
    <div className={styles.container}>
      <Input />
      <Results />
    </div>
  </ListingSearchProvider>
)

export default SearchModal
